"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textNode = void 0;
exports.textNode = {
    hasChildNodes: false,
    getEvaluatorFunction: ({ node }) => {
        return () => {
            let result;
            switch (node.value) {
                case 'jsNull':
                    result = null;
                    break;
                case 'jsUndefined':
                    result = undefined;
                    break;
                default:
                    result = node.value;
                    break;
            }
            return {
                node,
                inputs: [],
                output: { error: null, result },
            };
        };
    },
};
//# sourceMappingURL=text.js.map